/* Publish by EComposer at 2024-07-12 06:54:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-z4u8tzp0a5d"]=  window.__ectimmers["ecom-z4u8tzp0a5d"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-z4u8tzp0a5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z4u8tzp0a5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-av4k56iam2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-av4k56iam2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l0bjjetg71').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l0bjjetg71', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}